<template>
  <b-modal v-model="visible" title="Cập nhật thông tin sim cho MC" hide-footer centered>
    <div class="d-flex w-100">
      <div class="flex-fill">Thông tin MC</div>

      <b-form-group class="flex-fill">
        <SearchAutoComplete
          v-model="merchantId"
          :list="listMerchants"
          labelKey="customerName"
          placeholder="Tìm kiếm Merchant"
          @search="handleFetchMerchant"
        />
        <b-form-checkbox class="mt-2" v-model="isConfirmed">
          <span class="align-middle mt-2">Đã xác minh với MC</span>
        </b-form-checkbox>
      </b-form-group>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <b-button variant="outline-danger" class="mr-2" @click="closeModal" :disabled="isLoading">
        <b-icon icon="x" scale="2" aria-hidden="true" />
        Hủy bỏ
      </b-button>
      <b-button
        variant="outline-primary"
        @click="handleSubmit"
        :disabled="isLoading || !isConfirmed || !merchantId"
      >
        <b-spinner small v-show="isLoading" />
        <b-icon icon="check" scale="2" aria-hidden="true" v-show="!isLoading" />
        Xác nhận
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import { showMess } from '@/config/utils'
  import { DeviceService } from '@/services/device.service'
  import SearchAutoComplete from './SearchAutoComplete.vue'

  export default {
    name: 'UpdateInforSimCard',
    components: { SearchAutoComplete },
    data() {
      return {
        visible: false,
        isConfirmed: false,
        isLoading: false,
        serial: '',
        listMerchants: [],
        merchantId: '',
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      closeModal() {
        this.visible = false
        this.resetForm()
      },
      openModal(serial) {
        this.serial = serial
        this.visible = true
      },
      resetForm() {
        this.isConfirmed = false
        this.merchantId = ''
        this.serial = ''
      },
      async handleFetchMerchant(e) {
        await this.fetchData(e)
      },
      async fetchData(body) {
        const params = {
          keySearch: body || '',
          page: 1,
          limit: 10,
        }
        try {
          const response = await DeviceService.getMcHasContract(params)
          if (response.code === 1000) {
            this.listMerchants = response.data || []
          } else {
            showMess(this, 'Thất bại', response.message, 'danger', 'b-toaster-top-right', 3000)
          }
        } catch (e) {
          showMess(
            this,
            'Thất bại',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        }
      },
      async handleSubmit() {
        try {
          this.isLoading = true
          const body = {
            serial: this.serial,
            action: 'VERIFIED',
            customerId: this.merchantId,
          }
          const res = await DeviceService.updateSimForMc(body)
          if (res.code === 1000) {
            showMess(
              this,
              'Thành công',
              'Cập nhật thông tin sim thành công',
              'success',
              'b-toaster-top-right',
              3000
            )
            this.$emit('success')
            this.closeModal()
          } else {
            showMess(this, 'Thất bại', res.message, 'danger', 'b-toaster-top-right', 3000)
          }
        } catch (e) {
          showMess(
            this,
            'Thất bại',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>
<style lang="scss" scope>
  .custom-control-label::before,
  .custom-control-label::after {
    top: 0 !important;
  }
</style>
